// Above the comments panel and its launcher (z-index 19000-19001), which would otherwise cover the panel.
export const PANEL_Z = 19010;
// The colour popover and the discard confirm open over the panel.
export const POPUP_Z = PANEL_Z + 10;
